import { Component } from 'react';
import classnames from 'classnames';
import classBind from 'classnames/bind';

import styles from './styles.scss';

let cx = classBind.bind(styles);

export default class FormFieldset extends Component {
  render() {
    let className = cx({
      formFieldset: true,
      divider: this.props.divider,
      first: this.props.first,
    });

    return <div className={classnames(className)}>{this.props.children}</div>;
  }
}
